import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAssetNetDevice = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="url(#Asset_NetDevice_svg__a)"
      fillOpacity={0.5}
      d="M3.103 6.71A1.75 1.75 0 0 1 4.79 4.5h10.42a1.75 1.75 0 0 1 1.688 2.21l-2.045 7.5a1.75 1.75 0 0 1-1.689 1.29H6.837a1.75 1.75 0 0 1-1.689-1.29z"
    />
    <g fillOpacity={0.7} clipPath="url(#Asset_NetDevice_svg__b)">
      <path
        fill="url(#Asset_NetDevice_svg__c)"
        d="M13.632 8.496A5.1 5.1 0 0 0 10 6.992a5.1 5.1 0 0 0-3.632 1.504.56.56 0 0 0 0 .8.563.563 0 0 0 .8 0A3.96 3.96 0 0 1 10 8.12c1.072 0 2.08.416 2.832 1.176a.56.56 0 0 0 .8 0 .56.56 0 0 0 0-.8"
      />
      <path
        fill="url(#Asset_NetDevice_svg__d)"
        d="M7.872 10.008a.56.56 0 0 0 0 .8.563.563 0 0 0 .8 0 1.88 1.88 0 0 1 2.656-.008.56.56 0 0 0 .8 0 .56.56 0 0 0 0-.8 3.015 3.015 0 0 0-4.256.008"
      />
      <path
        fill="url(#Asset_NetDevice_svg__e)"
        d="M10.888 12.129a.88.88 0 1 1-1.76 0 .88.88 0 0 1 1.76 0"
      />
    </g>
    <defs>
      <linearGradient
        id="Asset_NetDevice_svg__a"
        x1={14.687}
        x2={-4.056}
        y1={12.578}
        y2={12.046}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#256CF7" />
        <stop offset={1} stopColor="#C8D9FC" />
      </linearGradient>
      <linearGradient
        id="Asset_NetDevice_svg__c"
        x1={12.375}
        x2={2.91}
        y1={8.807}
        y2={8.201}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#256CF7" />
        <stop offset={1} stopColor="#C8D9FC" />
      </linearGradient>
      <linearGradient
        id="Asset_NetDevice_svg__d"
        x1={11.435}
        x2={5.707}
        y1={10.485}
        y2={10.189}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#256CF7" />
        <stop offset={1} stopColor="#C8D9FC" />
      </linearGradient>
      <linearGradient
        id="Asset_NetDevice_svg__e"
        x1={10.558}
        x2={8.358}
        y1={12.541}
        y2={12.495}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#256CF7" />
        <stop offset={1} stopColor="#C8D9FC" />
      </linearGradient>
      <clipPath id="Asset_NetDevice_svg__b">
        <path fill="#fff" d="M6 6h8v8H6z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAssetNetDevice;
